import { resolveIcon } from "./included-icons"

export interface IncludedItem {
  icon?: string
  title_en: string
  desc_en?: string
}

// Five across is the row the Hebden page needs; fewer items spread to fill.
// Literal class names so Tailwind sees them.
const COLUMNS: Record<number, string> = {
  1: "grid-cols-1",
  2: "grid-cols-2",
  3: "grid-cols-2 sm:grid-cols-3",
  4: "grid-cols-2 lg:grid-cols-4",
  5: "grid-cols-2 sm:grid-cols-3 lg:grid-cols-5",
}

// The "What's included" row as the old Sanctuary site drew its "Why use
// Sanctuary Therapy Centre?" band: a navy line icon over a short label,
// centred, several to a row. The icon is the one the admin picked, or — when
// they left it on Auto — the one the label earns.
export default function IncludedTiles({ items }: { items: IncludedItem[] }) {
  if (items.length === 0) return null
  const columns = COLUMNS[Math.min(items.length, 5)]

  return (
    <div className={`grid ${columns} gap-x-6 gap-y-10`}>
      {items.map((item) => {
        const { Icon, emoji } = resolveIcon(item.icon ?? "", item.title_en)
        return (
          <div key={item.title_en} className="flex flex-col items-center gap-4 text-center">
            {Icon ? (
              <Icon aria-hidden className="h-16 w-16 text-teal" strokeWidth={1.25} />
            ) : (
              <span aria-hidden className="text-5xl leading-none">{emoji}</span>
            )}
            <span className="text-ink-body">{item.title_en}</span>
            {item.desc_en && <p className="-mt-2 text-sm text-ink-muted">{item.desc_en}</p>}
          </div>
        )
      })}
    </div>
  )
}
